<template>
  <b-navbar centered>
    <template slot="start">
      <div class="level">
        <div class="buttons is-centered">
          <router-link to="/" class="button is-secondary">
            <strong>Feed</strong>
          </router-link>
          <router-link to="/creators" class="button is-secondary">
            <strong>Creators</strong>
          </router-link>
          <router-link to="/about" class="button is-secondary">
            <strong>About</strong>
          </router-link>
          <a
            href="https://streamlabs.com/giupdates/merch"
            class="button is-secondary"
          >
            <strong>Merch</strong>
          </a>
          <router-link to="/sponsors" class="button is-secondary">
            <strong>Sponsors</strong>
          </router-link>
          <router-link to="/contact" class="button is-secondary">
            <strong>Contact</strong>
          </router-link>
        </div>
      </div>
    </template>
  </b-navbar>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
nav {
  border-top: 2px solid #bf9c5a;
  text-align: center;
  background-color: #0d0c10 !important;
  align-content: space-between !important;
}
a {
  color: ghostwhite;
  font-size: 1rem;
  padding-right: 1.25rem;
}
</style>
